import { Component, OnInit, HostBinding } from '@angular/core';
import { DumpInstitutionService, DumpType } from './dump-institution.service';
import { CurrentService, ProjectService, ElementsService } from 'dbweb-core';
import { TabsService } from '../home/tabs.service';

@Component({
	selector: 'common-dump-institution',
	templateUrl: './dump-institution.component.html',
	styleUrls: ['./dump-institution.component.scss'],
	providers: [DumpInstitutionService]
})
export class DumpInstitutionComponent implements OnInit {
	@HostBinding('class.c-dump-institution') hostClass = true;
	displayedColumns = ['index', 'Name', 'Tables'];
	readonly dumpTypeInstitution = DumpType.institution;
	readonly dumpTypeData = DumpType.data;
	dumpDone = false;
	taskURL: string;
	constructor(
		public svr: DumpInstitutionService,
		private project: ProjectService,
		public current: CurrentService,
		private tabs: TabsService,
		private eles: ElementsService
	) {}

	ngOnInit() {
		this.svr.init();
	}
	dump() {
		this.dumpDone = false;
		this.svr.dump().subscribe(v => {
			this.dumpDone = true;
			this.taskURL = this.project.frontURL('task', v.TaskInfoURL);
			this.eles.addElement(v.BrowseTaskElement);
			this.eles.setURLSign(v.TaskInfoURL, v.TaskInfoSign);
		});
	}
	close() {
		this.tabs.close();
	}
}
